"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Component_1 = require("./Component");
var Dashboard_1 = require("./Dashboard");
var Stack_1 = require("./Stack");
var Sync_1 = require("@twii/core/lib/model/Sync");
var ComponentTypes = require("./ComponentTypes");
var DashboardList = /** @class */ (function (_super) {
    __extends(DashboardList, _super);
    function DashboardList() {
        var _this = _super.call(this) || this;
        _this.sync = new Sync_1.Sync();
        _this._activeIndex = -1;
        _this.dashboards = [];
        _this._closeDisabled = false;
        _this._createDefaultDashboard = true;
        _this._saveDelay = 1000;
        _this._saveConfig = function (config) {
            _this.saver(config);
        };
        _this._loadDone = function (config) {
            _this.setConfig(config);
            if (_this.saver) {
                _this._configSaveDisposer = mobx_1.reaction(function () {
                    return _this.config;
                }, _this._saveConfig, { delay: _this.saveDelay });
            }
            if (_this.dashboardCount === 0) {
                _this.addDefaultDashboard();
            }
            _this.sync.syncEnd();
        };
        _this._loadError = function (error) {
            console.error(error);
            _this.setConfig(undefined);
            _this.sync.syncError(error);
        };
        _this._setDashboardViewports = function () {
            var active = _this.active;
            _this.dashboards.forEach(function (db) {
                db.setViewport(0, 0, db === active ? _this.width : 0, db === active ? _this.height : 0);
            });
        };
        _this._setViewportDisposer = mobx_1.autorun(_this._setDashboardViewports);
        return _this;
    }
    Object.defineProperty(DashboardList.prototype, "type", {
        get: function () {
            return ComponentTypes.dashboardList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardList.prototype, "createDefaultDashboard", {
        get: function () {
            return this._createDefaultDashboard;
        },
        set: function (value) {
            this.setCreateDefaultDashboard(value);
        },
        enumerable: true,
        configurable: true
    });
    DashboardList.prototype.setCreateDefaultDashboard = function (createDefaultDashboard) {
        this._createDefaultDashboard = createDefaultDashboard;
    };
    Object.defineProperty(DashboardList.prototype, "dashboardCount", {
        get: function () {
            return this.dashboards ? this.dashboards.length : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardList.prototype, "closeDisabled", {
        get: function () {
            return this._closeDisabled;
        },
        set: function (value) {
            this.setCloseDisabled(value);
        },
        enumerable: true,
        configurable: true
    });
    DashboardList.prototype.setCloseDisabled = function (closeDisabled) {
        this._closeDisabled = closeDisabled;
    };
    Object.defineProperty(DashboardList.prototype, "activeIndex", {
        get: function () {
            return this._activeIndex || 0;
        },
        set: function (value) {
            this.setActiveIndex(value);
        },
        enumerable: true,
        configurable: true
    });
    DashboardList.prototype.setActiveIndex = function (value) {
        if (value !== this._activeIndex) {
            this._activeIndex = value;
        }
    };
    Object.defineProperty(DashboardList.prototype, "active", {
        get: function () {
            return this.activeIndex >= 0 && this.activeIndex < this.dashboards.length ? this.dashboards[this.activeIndex] : undefined;
        },
        set: function (value) {
            this.setActive(value);
        },
        enumerable: true,
        configurable: true
    });
    DashboardList.prototype.setActive = function (value) {
        this.activeIndex = this.dashboards.indexOf(value);
    };
    Object.defineProperty(DashboardList.prototype, "config", {
        get: function () {
            return {
                type: this.type,
                activeIndex: this.activeIndex,
                dashboards: this.dashboards.map(function (d) { return d.config; }),
                closeDisabled: this._closeDisabled
            };
        },
        set: function (value) {
            this.setConfig(value);
        },
        enumerable: true,
        configurable: true
    });
    DashboardList.prototype.setConfig = function (value) {
        var _this = this;
        this.sync.syncStart();
        this.dashboards = [];
        var dashboardPromise;
        if (value && value.dashboards && value.dashboards.length > 0) {
            value.dashboards.forEach(function (dc) {
                var db = new Dashboard_1.Dashboard();
                _this.add(db);
                db.setConfig(dc);
            });
        }
        this.setActiveIndex(value && !isNaN(value.activeIndex) ? value.activeIndex : -1);
        this.setCloseDisabled(value ? value.removeItemsDisabled : undefined);
        this.sync.syncEnd();
    };
    DashboardList.prototype.add = function (dashboard, makeActive) {
        if (makeActive === void 0) { makeActive = true; }
        if (dashboard.parent !== this) {
            dashboard.removeFromParent();
            dashboard.parent = this;
            this.dashboards.push(dashboard);
            if (!dashboard.component && this.addApp) {
                var s = new Stack_1.Stack();
                dashboard.setComponent(s);
                s.addNew();
            }
            if (makeActive) {
                this.active = dashboard;
            }
        }
    };
    DashboardList.prototype.addDefaultDashboard = function () {
        if (this.dashboardCount === 0 && this.createDefaultDashboard && this.addApp) {
            var newDashboard = new Dashboard_1.Dashboard();
            newDashboard.setTitle("Dashboard 1");
            this.add(newDashboard, true);
        }
    };
    DashboardList.prototype.remove = function (node) {
        var idx = this.dashboards.indexOf(node);
        if (idx >= 0) {
            var dashboard = this.dashboards[idx];
            dashboard.parent = undefined;
            this.dashboards.splice(idx, 1);
            if (this.activeIndex >= this.dashboards.length) {
                this.setActiveIndex(this.dashboards.length - 1);
            }
            dashboard.close();
            if (this.dashboardCount === 0) {
                this.addDefaultDashboard();
            }
        }
    };
    Object.defineProperty(DashboardList.prototype, "saveDelay", {
        get: function () {
            return this._saveDelay;
        },
        set: function (value) {
            if (!isNaN(value) && value >= 0) {
                this._saveDelay = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    DashboardList.prototype.load = function () {
        if (this._configSaveDisposer) {
            this._configSaveDisposer();
            delete this._configSaveDisposer;
        }
        if (this.loader) {
            this.sync.syncStart();
            return this.loader().then(this._loadDone).catch(this._loadError);
        }
        return Promise.reject({ code: "ILLEGAL_STATE", message: "A loader has not been configured" });
    };
    DashboardList.prototype._findFirstChild = function (predicate) {
        var r;
        this.dashboards.some(function (d) {
            r = d.findFirst(predicate);
            return r ? true : false;
        });
        return r;
    };
    DashboardList.prototype._findAllChildren = function (predicate) {
        var r = [];
        var dr;
        this.dashboards.forEach(function (d) {
            dr = d.findAll(predicate);
            if (dr && dr.length > 0) {
                r = r.concat(dr);
            }
        });
        return r;
    };
    DashboardList.prototype.close = function () {
        this.dashboards.forEach(function (db) { return db.close(); });
        this.dashboards = [];
        this.setActiveIndex(-1);
        this.addDefaultDashboard();
    };
    DashboardList.prototype.clear = function () {
        this.close();
    };
    __decorate([
        mobx_1.observable
    ], DashboardList.prototype, "sync", void 0);
    __decorate([
        mobx_1.observable
    ], DashboardList.prototype, "_activeIndex", void 0);
    __decorate([
        mobx_1.observable
    ], DashboardList.prototype, "dashboards", void 0);
    __decorate([
        mobx_1.observable
    ], DashboardList.prototype, "_closeDisabled", void 0);
    __decorate([
        mobx_1.observable
    ], DashboardList.prototype, "_createDefaultDashboard", void 0);
    __decorate([
        mobx_1.computed
    ], DashboardList.prototype, "createDefaultDashboard", null);
    __decorate([
        mobx_1.action
    ], DashboardList.prototype, "setCreateDefaultDashboard", null);
    __decorate([
        mobx_1.computed
    ], DashboardList.prototype, "dashboardCount", null);
    __decorate([
        mobx_1.computed
    ], DashboardList.prototype, "closeDisabled", null);
    __decorate([
        mobx_1.action
    ], DashboardList.prototype, "setCloseDisabled", null);
    __decorate([
        mobx_1.computed
    ], DashboardList.prototype, "activeIndex", null);
    __decorate([
        mobx_1.action
    ], DashboardList.prototype, "setActiveIndex", null);
    __decorate([
        mobx_1.computed
    ], DashboardList.prototype, "active", null);
    __decorate([
        mobx_1.action
    ], DashboardList.prototype, "setActive", null);
    __decorate([
        mobx_1.computed
    ], DashboardList.prototype, "config", null);
    __decorate([
        mobx_1.action
    ], DashboardList.prototype, "setConfig", null);
    __decorate([
        mobx_1.action
    ], DashboardList.prototype, "add", null);
    __decorate([
        mobx_1.action
    ], DashboardList.prototype, "_loadDone", void 0);
    __decorate([
        mobx_1.action
    ], DashboardList.prototype, "_loadError", void 0);
    __decorate([
        mobx_1.action
    ], DashboardList.prototype, "load", null);
    __decorate([
        mobx_1.action
    ], DashboardList.prototype, "close", null);
    __decorate([
        mobx_1.action
    ], DashboardList.prototype, "clear", null);
    return DashboardList;
}(Component_1.Component));
exports.DashboardList = DashboardList;
